(function($) {
  $( document ).ready(function() {
    $('.accordionContent-accordion__title').click(function(event) {
      event.preventDefault()
      event.stopPropagation()

      $(this).closest('.accordionContent').toggleClass('active')
    });
  })
})(jQuery);